import { FC } from 'react'

import { IconName, Page, PageFace } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { BatchSideBar } from '~bank-bsa-reporting/components'

import { DetailsPageProps } from './DetailsPage.types'
import { BatchItems, GeneralInformation } from './components'

export const DetailsPage: FC<DetailsPageProps> = (props) => {
  const { isPending, data, onDelete } = props

  const { id, enableDelete } = data || {}

  return (
    <Page
      isPending={isPending}
      title={`ID ${id}`}
      subTitle="Batch Page"
      face={PageFace.SECONDARY}
      actions={
        enableDelete && (
          <IconButton onClick={onDelete} icon={IconName.DELETE} face="neutral">
            Delete Batch
          </IconButton>
        )
      }
    >
      {!!data && (
        <>
          <BatchSideBar type={data.type} />
          <GeneralInformation isPending={isPending} data={data} />
          <BatchItems items={data.subjectsInfo} type={data.type} />
        </>
      )}
    </Page>
  )
}
